/* =========================================================================
 * Kkumi · Copy to clipboard — window.KKCopy
 * -------------------------------------------------------------------------
 * The one way a storefront script copies text. Two parts:
 *
 *   KKCopy.write(text) → Promise<boolean>
 *     The Clipboard API, falling back to a hidden <textarea> and
 *     execCommand('copy') (the theme editor's preview is an iframe, where some
 *     browsers refuse the Clipboard API). Resolves true when the text copied.
 *
 *   [data-kk-copy="TEXT"] — a copy button. Delegated on the document, so markup
 *   built by any script (innerHTML strings included) works with no wiring:
 *
 *     <button type="button" class="button button--small"
 *             data-kk-copy="KR-ABCDE-FGHIJ" data-kk-copied="Copied">
 *       <span data-kk-copy-label>Copy code</span>
 *     </button>
 *
 *   A click copies TEXT, then for two seconds shows data-kk-copied (default
 *   "Copied") in the [data-kk-copy-label] child (or the button's own text when
 *   it has no child elements), adds .is-copied, and announces it politely to
 *   screen readers. Copying is instant, so there is no busy spinner (FRONTEND.md).
 *   Both words are merchant copy: the host passes them in as data attributes,
 *   never hardcoded here beyond the "Copied" fallback.
 *
 * First user: the free-shipping reward code. Shopify works out shipping only at
 * checkout, so the storefront never applies that code to the cart: it shows
 * the code with a Copy button and tells the member to enter it at checkout
 * (club page wallet and toast, launcher, account tabs, cart "saved codes").
 * ========================================================================= */
(function () {
  'use strict';
  if (window.KKCopy) return;

  var RESET_MS = 2000;

  // The fallback for browsers (or iframes) that refuse the Clipboard API.
  function viaTextarea(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.setAttribute('aria-hidden', 'true');
    // 16px keeps iOS from zooming; fixed + transparent keeps the page from scrolling or flashing.
    ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none;font-size:16px;';
    var prev = document.activeElement;
    document.body.appendChild(ta);
    ta.select();
    try { ta.setSelectionRange(0, ta.value.length); } catch (e) { /* older WebKit */ }
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    if (prev && prev.focus) { try { prev.focus({ preventScroll: true }); } catch (e) { /* gone from the page */ } }
    return ok;
  }

  function write(text) {
    text = String(text == null ? '' : text);
    if (!text) return Promise.resolve(false);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return viaTextarea(text); });
    }
    return Promise.resolve(viaTextarea(text));
  }

  // One polite live region for the whole page: "Copied" is spoken, not just shown.
  var live = null;
  function announce(msg) {
    if (!msg) return;
    if (!live || !live.isConnected) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30); // empty first, so the same word is read again
  }

  // The button says "Copied" for a moment, then goes back to what it said.
  function flash(btn) {
    var label = btn.querySelector('[data-kk-copy-label]') || btn;
    var copied = btn.getAttribute('data-kk-copied') || 'Copied';
    // A button with an icon and no label child keeps its markup: only the state class changes.
    var swap = label !== btn || !btn.children.length;
    if (btn.__kkCopyTimer) clearTimeout(btn.__kkCopyTimer);
    else if (swap) btn.__kkCopyWas = label.textContent;
    if (swap) label.textContent = copied;
    btn.classList.add('is-copied');
    announce(copied);
    btn.__kkCopyTimer = setTimeout(function () {
      if (swap) label.textContent = btn.__kkCopyWas;
      btn.classList.remove('is-copied');
      btn.__kkCopyTimer = 0;
    }, RESET_MS);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-kk-copy]') : null;
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    write(btn.getAttribute('data-kk-copy')).then(function (ok) { if (ok) flash(btn); });
  });

  window.KKCopy = { write: write };
})();
